import SubHeading from '@components/elements/Text/SubHeading';

const AdminModule = () => {
  return <div>Hello Admin</div>;
};

export default AdminModule;
